'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.formatImage = void 0;
var clear = function (m) {
        try {
            if (!m)
                return m;
            if (m.includes('d.ifengimg.com/')) {
                var i = (m = m.split('d.ifengimg.com/').pop()).split('/');
                i.shift(), m = i.join('/');
            }
            return m.includes('http://') && (m = m.substring(7)), m.includes('https://') && (m = m.substring(8)), m.includes('//') && (m = m.substring(2)), m;
        } catch (i) {
            return console.error(i), m;
        }
    }, ifengImgDomain = ["x0.ifengimg.com","y0.ifengimg.com","y1.ifengimg.com","y2.ifengimg.com","y3.ifengimg.com","m0.ifengimg.com","m1.ifengimg.com","m2.ifengimg.com","m3.ifengimg.com","img.ifeng.com","mimg.ifeng.com","s0.mimg.ifeng.com","s1.mimg.ifeng.com","s2.mimg.ifeng.com","s3.mimg.ifeng.com","s4.mimg.ifeng.com","a0.ifengimg.com","a1.ifengimg.com","a2.ifengimg.com","a3.ifengimg.com","s0.ifengimg.com","s1.ifengimg.com","s2.ifengimg.com","s3.ifengimg.com","res.ent.ifeng.com","res.news.ifeng.com","res.fashion.ifeng.com","blogfile.ifeng.com","entimg.ifeng.com","res.health.ifeng.com","res.book.ifeng.com","imgs.diantai.ifeng.com","img.ugc.ifeng.com","img1.ugc.ifeng.com","res.phtv.ifeng.com","bbsfile.ifeng.com","res.img.ifeng.com","c0.ifengimg.com","c1.ifengimg.com","p0.ifengimg.com","p1.ifengimg.com","p2.ifengimg.com","p3.ifengimg.com","q0.ifengimg.com","p0.iikuzhan.com","yj.fcai.com","my.ifengimg.com","sy.ifeng.com","c0.fengshows.com","c1.fengshows.com","p0.fengshows.com","p1.fengshows.com","p2.fengshows.com","p3.fengshows.com","y0.fengshows.com","y1.fengshows.com","y2.fengshows.com","y3.fengshows.com","e0.ifengimg.com"], checkDomain = function (i) {
        try {
            if (!i)
                return i;
            var m = i.split('/')[0];
            return !!ifengImgDomain.includes(m);
        } catch (i) {
            return console.error(i), !1;
        }
    }, formatImage = function (m, i, e) {
        var o = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : 70;
        try {
            if (!m)
                return m;
            if (m = clear(m.trim()), !checkDomain(m))
                return '//'.concat(m);
            var g = [];
            return i && g.push('w'.concat(i)), e && g.push('h'.concat(e)), o && g.push('q'.concat(o)), 'undefined' != typeof window && void 0 !== window.chrome ? '//d.ifengimg.com/'.concat(g.join('_'), '_webp/').concat(clear(m)) : '//d.ifengimg.com/'.concat(g.join('_'), '/').concat(clear(m));
        } catch (i) {
            return console.error(i), m;
        }
    };
exports.formatImage = formatImage;